import { nonempty, string as stringBase } from 'superstruct'

export const string = () => nonempty(stringBase())
export const stringEmptyable = stringBase
